import { Alert, Dialog, Stack, TextField } from '@all-manager/design-system-v2';
import { Controller } from 'react-hook-form';
import { DocumentType } from '../../../../types';
import ProviderAutocomplete from '../../../providers/external-components/ProviderAutocomplete/ProviderAutocomplete';
import DocumentTypeSelect from '../../components/DocumentTypeSelect/DocumentTypeSelect';
import useEditDocumentModal, { type EditableDocument } from './useEditDocumentModal';

type Props = {
  document: EditableDocument;
  onClose: () => void;
};

export default function EditDocumentModal(props: Props) {
  const { form, handleSubmit, serverError, isConfirmationPending } = useEditDocumentModal(props);

  return (
    <Dialog
      open
      onClose={props.onClose}
      onSubmit={handleSubmit}
      maxWidth="sm"
      fullWidth
      title="Modifier le document"
      closeLabel="Fermer"
      actions={{
        primaryAction: {
          label: 'Enregistrer',
          type: 'submit',
          loading: isConfirmationPending,
        },
        secondaryAction: {
          label: 'Annuler',
          onClick: props.onClose,
          disabled: isConfirmationPending,
        },
      }}
    >
      <Stack spacing={3}>
        {serverError ? <Alert severity="error">{serverError}</Alert> : null}

        <Controller
          name="name"
          control={form.control}
          render={({ field, fieldState }) => (
            <TextField
              name={field.name}
              inputRef={field.ref}
              onBlur={field.onBlur}
              onChange={field.onChange}
              value={field.value}
              label="Nom"
              fullWidth
              required
              autoFocus
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          )}
        />

        <Controller
          name="type"
          control={form.control}
          render={({ field }) => (
            <DocumentTypeSelect
              value={field.value ?? ''}
              onChange={function handleTypeChange(newType) {
                field.onChange(newType as DocumentType);
              }}
              label="Nature"
              fullWidth
              size="medium"
            />
          )}
        />

        <Controller
          control={form.control}
          name="provider_id"
          render={({ field, fieldState }) => (
            <ProviderAutocomplete
              {...field}
              label="Prestataire"
              fullWidth
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              defaultSearch={form.watch('provider_name')}
              onChangeText={(value) => form.setValue('provider_name', value)}
            />
          )}
        />
      </Stack>
    </Dialog>
  );
}
